import style from "./style.css";
import { isValidValue } from "../../utils/checks";

const GameStatusInfo = ({ game }) => {
  if (!isValidValue(game)) {
    return (
      <div className={style.game_info}>
        <span className={style.game_score}>-</span>
      </div>
    );
  }
  const date = new Date(game.kickOffTime);
  const timeString = date.toLocaleTimeString(navigator.language, {
    hour: "2-digit",
    minute: "2-digit",
  });

  const dateString = date.toLocaleDateString("en-gb", {
    month: "short",
    day: "numeric",
  });

  if (game.status === "POSTPONED" || game.status === "SUSPENDED") {
    return (
      <div className={style.game_info}>
        <span className={style.game_canceled}>{game.status}</span>
        <span className={style.game_status}>{dateString}</span>
      </div>
    );
  }
  if (game.status === "NOT_STARTED") {
    return (
      <div className={style.game_info}>
        <span className={style.time}>{timeString}</span>
        <span className={style.date}>{dateString}</span>
      </div>
    );
  }

  return (
    <div className={style.game_info}>
      <span className={style.game_score}>
        {game.homeGoals} - {game.awayGoals}
      </span>
      {game.status === "IN_PROGRESS" ? (
        <span className={style.game_live_status}>
          {game.elapsedTime ? `${game.elapsedTime}'` : "Live"}
        </span>
      ) : game.status === "HALFTIME" ? (
        <span className={style.game_live_status}>HT</span>
      ) : (
        <span className={style.game_status}>{dateString}</span>
      )}
    </div>
  );
};

export default GameStatusInfo;
